/* src/app/notification-settings/location-settings-grid/location-settings-grid.component.scss */
.location-settings {
  margin-top: 20px;
  border-collapse: separate;
  border-spacing: 0;
}
.location-settings th {
  border: 1px solid #757575;
  border-left: none;
}
.location-settings td {
  border-right: 1px solid #757575;
  border-bottom: 1px solid #757575;
  vertical-align: middle;
  padding: 0 28px;
}
.setting-header {
  position: sticky;
  background-color: white;
  top: 0px;
  z-index: 2;
}
.setting-header > div {
  display: flex;
  justify-content: space-between;
}
.setting-header .ups-icon {
  color: #757575 !important;
  padding-top: 8px;
  padding-right: 6px;
  padding-left: 8px;
}
.setting-header.error {
  outline: 2px solid #C91A13 !important;
  outline-offset: -2px;
}
::ng-deep .setting-header.error on-off-tri-toggle {
  position: relative;
}
::ng-deep .setting-header.error on-off-tri-toggle:after {
  font-family: upsicons, fantasy !important;
  content: "\e638" !important;
  color: #C91A13;
  position: absolute;
  top: calc(50% - 0.7em);
  right: -20px;
}
.top-left {
  border: none !important;
  border-bottom: 1px solid #757575 !important;
  border-right: 1px solid #757575 !important;
  position: sticky;
  top: 0px;
  z-index: 2;
  background-color: white;
  width: 365px;
  height: 120px;
}
.top-left .location-search-container {
  padding-right: 32px;
}
.top-left .location-search-container .location-search {
  display: flex;
  flex-flow: column;
}
.top-left .location-search-container .location-search .search.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e668" !important;
  color: #FFF;
}
.top-left .location-search-container .location-search .clear.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e67b" !important;
  color: #FFF;
}
.top-left .search-message {
  font-style: italic;
  font-weight: normal;
  padding-top: 0.5rem;
}
.top-left.no-results {
  border: none !important;
}
/*# sourceMappingURL=location-settings-grid.component.css.map */
